// AdhocPage.jsx
import React, { useEffect, useState } from "react";
import FadeTransition from "../../components/fadeTransition";
import Adhoc_InHouse from "./adhoc_inhouse";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { resetRenderAdhoc } from "../../Redux/Reducers/adhocReducer";
import { sendGuestRequest } from "../../Redux/Actions/guestRequestAction";
import { View } from "react-native";
import HeaderWithBack from "../../components/Header/headerWithBack";
import Adhoc_Nor1 from "./adhoc_nor1";
import { HOMEPAGE, applyAdhochNor1 } from "../../Redux/Actions/adhocAction";
import { setRenderFlashMessage } from "../../Redux/Actions/appConfigAction";
import { useCssStyle } from "../../customHook/getCssStyle";

const ADHOC_STORAGE_KEY = 'adHocEventShownIDList';

export const AdhocPage = (props) => {
    const { adhocList, handleNext, handleGoBack } = props;
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const { adhocWidgetData, serverTimeDate, logo, activeUpsellType } = useSelector(
        state => ({
            adhocWidgetData: state.adhocSlice.adhocWidgetData,
            serverTimeDate: state.serverDateTimeSlice.serverTimeDataObj,
            logo: state.deviceConfigSlice.webAppWidgetsInfo?.brandingInfo?.hotelLogoImageUrl || '',
            activeUpsellType: state.deviceConfigSlice.webAppWidgetsInfo?.activeUpsellType
        }),
        shallowEqual
    );

    const adhocDataList = adhocList
        ? Array.isArray(adhocList) ? adhocList : [adhocList]
        : adhocWidgetData?.[HOMEPAGE] || [];

    const [adhocDataListLocalCopy, setAdhocDataListLocalCopy] = useState([]);
    const [showSingleAdhoc, setShowSingleAdhoc] = useState({
        showSingleAdhocBool: false,
        adhocType: null,
        adhocId: null,
    });
    const [pendingRequest, setPendingRequest] = useState([]);
    const [acceptedRequest, setAcceptedRequest] = useState([]);

    const [nor1PendingOfferIds, setNor1PendingOfferIds] = useState([]);
    const [nor1AcceptedOfferIds, setNor1AcceptedOfferIds] = useState(new Set());

    const handleSkip = async () => {
        const adHocEventShownIDListStr = await AsyncStorage.getItem(ADHOC_STORAGE_KEY);
        const adHocEventShownIDList = JSON.parse(adHocEventShownIDListStr) || [];
        const serverDate = serverTimeDate.date && serverTimeDate.date.split('T')[0];

        const updatedAdHocEventShownIDList = [...adHocEventShownIDList]; 
        if (activeUpsellType === "NOR1") {
            adhocDataListLocalCopy?.forEach(upsell =>
                upsell?.upsellOffers?.forEach(upsellOffer =>
                    upsellOffer?.offers?.forEach(offer => {
                        const shownAdhocData = {
                            id: offer.offerId,
                            adhocEventShownDate: serverDate,
                        };

                        const existingIndex = updatedAdHocEventShownIDList.findIndex(
                            event => event.id === shownAdhocData.id
                        );

                        if (existingIndex > -1) {
                            updatedAdHocEventShownIDList[existingIndex] = shownAdhocData;
                        } else {
                            updatedAdHocEventShownIDList.push(shownAdhocData);
                        }
                    })
                )
            );
        } else {
            adhocDataListLocalCopy.forEach(adhoc => {
                const shownAdhocData = {
                    id: adhoc.id,
                    triggerType: adhoc.type,
                    adhocEventShownDate: serverDate,
                };
    
                const existingIndex = updatedAdHocEventShownIDList.findIndex(
                    event => event.id === shownAdhocData.id && event.triggerType === shownAdhocData.triggerType
                );
    
                if (existingIndex > -1) {
                    updatedAdHocEventShownIDList[existingIndex] = shownAdhocData;
                } else {
                    updatedAdHocEventShownIDList.push(shownAdhocData);
                }
            });
        }

        await AsyncStorage.setItem(ADHOC_STORAGE_KEY, JSON.stringify(updatedAdHocEventShownIDList));

        dispatch(resetRenderAdhoc());
        // dispatch(setOverlayVisible(false));

        if(handleNext){
            handleNext();
        }
    };

    const handleBack = () => {
        if(showSingleAdhoc.showSingleAdhocBool){
            setShowSingleAdhoc({ showSingleAdhocBool: false, adhocType: null, adhocId: null });
        } else if (handleGoBack){
            handleGoBack()
        }
    };

    const handleShowSingleAdhoc = (adhoc) => {
        setShowSingleAdhoc({
            showSingleAdhocBool: true,
            adhocType: adhoc.type,
            adhocId: adhoc.id,
        });
    };

    const removePendingRequestData = (data) => {
        setPendingRequest(prev =>
            prev.filter(r => !(r.adhocId === data.adhocId && r.adhocType == data.adhocType && r.qualityPlusRequestId === data.qualityPlusRequestId))
        );
    };

    const addPendingRequestData = (data) => {
        const entry = { adhocId: data.adhocId, adhocType: data.adhocType, qualityPlusRequestId: data.qualityPlusRequestId };
        setPendingRequest(prev => {
            if (prev.some(r => r.adhocId === entry.adhocId && r.adhocType == entry.adhocType && r.qualityPlusRequestId === entry.qualityPlusRequestId)) {
                return prev;
            }
            return [...prev, entry];
        });
    };

    const addAcceptedRequestData = (data) => {
        const entry = { adhocId: data.adhocId, adhocType: data.adhocType, qualityPlusRequestId: data.qualityPlusRequestId };
        setAcceptedRequest(prev => {
            if (prev.some(r => r.adhocId === entry.adhocId && r.adhocType == entry.adhocType && r.qualityPlusRequestId === entry.qualityPlusRequestId)) {
                return prev;
            }
            return [...prev, entry];
        });
    };

    const removeRequestedQps = (data) => {
        return data.map(event => {
            const updatedList = event.qualityPlusRequestList?.filter(qp => !qp.isRequested) || [];
            if (event.multimediaType !== 'Upsell' || (event.multimediaType === 'Upsell' && updatedList.length > 0)) {
                return { ...event, qualityPlusRequestList: updatedList };
            }
            return null;
        }).filter(Boolean);
    };

    const handleUpsellRequest = async (adhocData, qualityPlusRequestId) => {
        const pendingRequestData = { adhocId: adhocData.id, adhocType: adhocData.type, qualityPlusRequestId };
        addPendingRequestData(pendingRequestData);

        const result = await dispatch(sendGuestRequest([{
            serviceRequestId: qualityPlusRequestId,
            quantity: 1,
        }]));

        removePendingRequestData(pendingRequestData);
        if (result?.status === 'SUCCESS') {
            addAcceptedRequestData(pendingRequestData);
        }
    };


    const handleNor1OfferSelect = async (offer) => {
        const offerId = offer.offerId;

        setNor1PendingOfferIds(prev => [...prev, offerId]);

        const { status, message } = await dispatch(applyAdhochNor1(offerId));

        setNor1PendingOfferIds(prev => prev.filter(id => id !== offerId));

        if (!status) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message }));
            return;
        }

        setNor1AcceptedOfferIds(prev => new Set([...prev, offerId]));
    };

    useEffect(() => {
        if (!activeUpsellType || activeUpsellType ==="") {
            const updatedAdhocData = removeRequestedQps(adhocDataList);
            if (updatedAdhocData.length > 0) {
                setAdhocDataListLocalCopy(updatedAdhocData);
            } else {
                handleSkip();
            }
        } else {
            setAdhocDataListLocalCopy(adhocDataList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FadeTransition duration={300} style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}>
            <View style={getStyles(['widgetRootContainer', 'adhocRootContainer'])} id='widgetRootContainer adhocRootContainer'>
                <HeaderWithBack hideBackButton={true} handleCustomBackPress={handleGoBack} />
                {activeUpsellType === "NOR1" ? (
                    <Adhoc_Nor1
                        adhocDataListLocalCopy={adhocDataListLocalCopy}
                        handleSkip={handleSkip}
                        pendingOfferIds={nor1PendingOfferIds}
                        acceptedOfferIds={nor1AcceptedOfferIds}
                        handleOfferSelect={handleNor1OfferSelect}
                    />
                ) : (
                    <Adhoc_InHouse
                        pendingRequest={pendingRequest}
                        acceptedRequest={acceptedRequest}
                        handleUpsellRequest={handleUpsellRequest}
                        adhocDataListLocalCopy={adhocDataListLocalCopy}
                        showSingleAdhoc={showSingleAdhoc}
                        handleShowSingleAdhoc={handleShowSingleAdhoc}
                        handleSkip={handleSkip}
                        handleBack={handleBack}
                    />
                )}
            </View>
        </FadeTransition>
    );
};